/**
 * ============================================================================
 * StatusBadge — small status pill for the ReviewCalendar rows.
 * Owner: Phase 7 — Management Review Module (Agent F).
 * ============================================================================
 */

import styles from './ReviewCalendar.module.css';
import type { ReviewStatus } from './useReviewCalendarQuery';

const CLASS_BY_STATUS: Record<ReviewStatus, string> = {
  SCHEDULED: styles.statusScheduled!,
  IN_PROGRESS: styles.statusInProgress!,
  HELD: styles.statusHeld!,
  MINUTES_DRAFT: styles.statusMinutesDraft!,
  MINUTES_FINALIZED: styles.statusMinutesFinalized!,
  CLOSED: styles.statusClosed!,
  CANCELLED: styles.statusCancelled!,
};

export interface StatusBadgeProps {
  status: ReviewStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span
      className={`${styles.statusBadge} ${CLASS_BY_STATUS[status]}`}
      aria-label={`Review status: ${status}`}
    >
      {status.replace(/_/g, ' ')}
    </span>
  );
}
